function truncate(text: string, max = 40, replaceWith = '...') {
  return text.length > max ? text.substr(0, max - 1) + replaceWith : text;
}

export function truncateFilename(text: string, max = 30, replaceWith = '...') {
  const txt = text.split('.');
  txt[0] = truncate(txt[0] ?? '', max, replaceWith);
  return txt.join('.');
}

export const convertCamelCaseToSpace = (text: string) => {
  const result = text.replace(/([A-Z])/g, ' $1');
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
};

type SplitBy = string | RegExp;

export const beautifyWords = <T extends string | undefined | null>(
  label?: T,
  splitBy: SplitBy = '_'
): T extends string ? string : undefined =>
  label
    ?.toLocaleLowerCase()
    .split(splitBy)
    .join(' ')
    .split(' ')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ') as T extends string ? string : undefined;

export const switchCaseToFirstWordCapitalized = beautifyWords;

export const beautifyName = (label?: string | null, splitBy: SplitBy = '_') =>
  capitalizeFirstLetter(label?.toLocaleLowerCase().split(splitBy).join(' ').toString());

export const removeUnderscore = (label: string) => label.split('_').join(' ').toString();

export const capitalizeFirstLetter = (string: string = ''): string => string.charAt(0).toUpperCase() + string.slice(1);

export const capitalizeOnlyFirstLetter = (string: string): string => capitalizeFirstLetter(string.toLocaleLowerCase());

export const convertToSnakeCase = (string: string = ''): string =>
  string
    .trim()
    .replace(/[^a-zA-Z0-9]/g, '-') // Replace non-alphanumeric characters with hyphens.
    .replace(/-$/, '') // Replace final hyphen, if present, with an empty string.
    .trimEnd()
    .toLowerCase();

export function normalizeString(str: undefined): undefined;
export function normalizeString(str: string): string;
export function normalizeString(str: string | undefined): string | undefined;
export function normalizeString(str: string | undefined): string | undefined {
  return str?.trim()?.replace(' ', ' ')?.toLocaleUpperCase();
}

export const camelCaseToTitleCase = (str: string, removePrefix?: string) => {
  if (!str) return '';

  // Remove prefix if it exists.
  const sanitisedStr = removePrefix ? str.replace(new RegExp(`^${removePrefix}`), '') : str;

  // Convert camelCase to space-separated words
  const withSpacesStr = sanitisedStr.replace(/([A-Z])/g, ' $1');

  return capitalizeFirstLetter(withSpacesStr.trim());
};

export const toCamelCase = (str: string) => {
  return str.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());
};
